import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BasePeriodicBackup from '../../AbstractObjects/GatewayPlan/InnerPages/BasePeriodicBackup';
import {useTranslation} from "react-i18next";
import {periodicBackupIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.serviceBackup;
const pageId = pageSchema.pageId;

function GatewayPeriodicBackup({
    gatewayObject,
    planObject,
    setGatewayData,
    setEditorPageId
}) {
    const { t } = useTranslation();
    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.PERIODIC_BACKUP')}
            icon={periodicBackupIcon}
        >
            <BasePeriodicBackup
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
                setEditorPageId={setEditorPageId}
            />
        </LockToPlanContainer>
    );
}

export default GatewayPeriodicBackup;